import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Indemnité transport — bus stylisé duotone */
export const TransportIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Fenêtres menthe */}
      <rect x="5" y="7.5" width="3.5" height="4" rx="0.5" fill="var(--equiply-icon-bg)" />
      <rect x="10.25" y="7.5" width="3.5" height="4" rx="0.5" fill="var(--equiply-icon-bg)" />
      <rect x="15.5" y="7.5" width="3.5" height="4" rx="0.5" fill="var(--equiply-icon-bg)" />
      {/* Carcasse */}
      <path
        d="M4 17V5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5V17"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path
        d="M4 14h16M4 17v2M20 17v2"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Roues */}
      <circle cx="7.5" cy="19" r="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <circle cx="16.5" cy="19" r="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
TransportIcon.displayName = "TransportIcon";
